import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';

import Reactions from '../../../../components/reactions';
import KbPostService from '../../../../services/kbPost.service';
import sh from '../../../../helpers/string.helper';
import './style.css';

const htmlToComponents = new Parser().parse;

const Post = ({
  activePost,
  backgroundColor,
}) => (
  <div className="kb2step kb2step1 boxs">
    {activePost &&
    <React.Fragment>
      <div className={activePost ? 'Blogs2' : 'box'}>
        <div className="BlogsBox BlogsBoxkb imrtant-style">
          <h5 className="post-title">{activePost.title}</h5>
          {activePost.content && htmlToComponents(sh.replaceSpecialChars(activePost.content))}
        </div>
      </div>
      <Reactions
        cssClass={`emoj-list ${backgroundColor}`}
        model_id={activePost.id}
        model_name={KbPostService.modelName}
      />
    </React.Fragment>
    }
  </div>
);

Post.propTypes = {
  activePost: PropTypes.object,
  backgroundColor: PropTypes.string.isRequired,
};

export default Post;



// WEBPACK FOOTER //
// ./src/views/modules/kb/post/Post.jsx